// prettier-ignore
import {
  pipe,
  filter,
  sort,
  slice,
  // log,
} from '../../functional/functional';

export default function getStudentActivityProgress({
  progresses,
  activityConf,
}) {
  activityConf = activityConf || {};
  const { miniactivities } = activityConf;
  let results = pipe(filterNonZero, sortByProgressDesc)(progresses);

  if (miniactivities) {
    results = miniactivities.map((miniactivityConf) => {
      return pipe(
        filterByMiniactivity(miniactivityConf.miniactivityType),
        sortMostCorrectFirstIfEqProgress,
        slice(0, miniactivityConf.options.repetitions || undefined),
        discardAfterFirstIncomplete,
        wrapWithMetaData(miniactivityConf)
      )(results);
    });
  } else {
    results = pipe(
      sortMostCorrectFirstIfEqProgress,
      // log(' sorted '),
      slice(0, activityConf.options?.repetitions || undefined),
      // log(' sliced '),
      discardAfterFirstIncomplete,
      //log(' discardeIncomplete '),
      wrapWithMetaData(activityConf),
      toArray
    )(results);
  }
  return results;
}

const filterNonZero = filter((p) => p.data.progress > 0);

const discardAfterFirstIncomplete = (progresses) => {
  const completeProgresses = filter((p) => p.data.progress == 100)(progresses);
  return slice(0, completeProgresses.length + 1)(progresses);
};

export const sortByDateDesc = sort(
  (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
);

export const sortByProgressDesc = sort(
  (a, b) => b.data.progress - a.data.progress
);

const filterByMiniactivity = (miniType) => (progresses) => {
  return progresses.filter((p) => p?.data.miniactivityType == miniType);
};

export const sortMostCorrectFirstIfEqProgress = sort((a, b) =>
  b.data.progress == a.data.progress ? b.data.correct - a.data.correct : 0
);

const wrapWithMetaData = (activityConf) => (progresses) => {
  const {
    options: { repetitions } = {},
    progress,
    correctness,
    canLoadProgress,
    miniactivityType,
  } = activityConf;
  const wrappedProgresses = {
    progressSlots: progresses.map((p) => ({
      progress: p.data.progress,
      correct: p.data.correct,
      updatedAt: p.updatedAt,
    })),
    repetitions,
    progress,
    correctness,
    canLoadProgress,
  };
  if (miniactivityType) wrappedProgresses.miniactivityType = miniactivityType;
  return wrappedProgresses;
};

const toArray = (...results) => [...results];
